import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import '../Font&Color.css';
import '../thumbnail&details.css';
import '../divs.css';

export default function 채용링크() {
  const navigate = useNavigate();

  useEffect(() => {
    // 새 탭으로 채용 링크 열기
    window.open("https://hanjinpl.career.rivers.co.kr/", "_blank");

    // 이전 페이지로 돌아가기 (뒤로가기)
    // 현재 페이지가 히스토리에 쌓인 후 navigate(-1) 호출
    setTimeout(() => {
      navigate('/인재채용/careerinfo');
    }, 100); // 100ms 정도 지연
  }, [navigate]);

  return <h5>채용 링크를 새 탭에서 열고 이전 페이지로 돌아갑니다...</h5>;
}
